import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "giveaway-banner" }
const _hoisted_2 = { class: "banner-copy" }
const _hoisted_3 = ["aria-label"]

import LocaleLink from '@/components/feedback/LocaleLink.vue';
import GiveawayEmblem from './GiveawayEmblem.vue';
import GiveawayTime from './GiveawayTime.vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'GiveawayBanner',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("aside", _hoisted_1, [
    _createVNode(GiveawayEmblem, { class: "banner-emblem" }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("strong", null, _toDisplayString(_ctx.$t('giveaway.bannerTitle')), 1),
      _createElementVNode("p", null, [
        _createVNode(GiveawayTime, { compact: "" })
      ])
    ]),
    _createElementVNode("nav", {
      "aria-label": _ctx.$t('giveaway.title')
    }, [
      _createVNode(LocaleLink, {
        class: "entry-link",
        to: { name: 'community_solo' }
      }, {
        default: _withCtx(() => [
          _cache[0] || (_cache[0] = _createElementVNode("span", {
            class: "material-icons",
            "aria-hidden": "true"
          }, "person", -1)),
          _createTextVNode(_toDisplayString(_ctx.$t('giveaway.soloShortCTA')), 1)
        ]),
        _: 1
      }),
      _createVNode(LocaleLink, {
        class: "entry-link",
        to: { name: 'community_group' }
      }, {
        default: _withCtx(() => [
          _cache[1] || (_cache[1] = _createElementVNode("span", {
            class: "material-icons",
            "aria-hidden": "true"
          }, "groups", -1)),
          _createTextVNode(_toDisplayString(_ctx.$t('giveaway.groupShortCTA')), 1)
        ]),
        _: 1
      }),
      _createVNode(LocaleLink, {
        class: "rules-link",
        to: { name: 'support', hash: '#giveaway' }
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('wiki.rules')), 1)
        ]),
        _: 1
      })
    ], 8, _hoisted_3)
  ]))
}
}

})